import React from "react";
import s from "./index.module.css";
import { strengthStatus } from "./strength-labels";

// Shared password-strength widget used by every form that lets a user set
// a password. Driven by the { score, missingElements } the usePasswordStrength
// hook already returns, so callers only hand us those two.
//
// Rendering decisions tracked in the client complaint this file ships with:
// - explicit "HASŁO SŁABE/ŚREDNIE/SILNE" label next to the bar instead of
//   relying on bar colour alone
// - taller bar, higher-contrast colours
// - missing-requirement list in a readable red with ✗ markers (was tiny grey)
export const PasswordStrengthMeter = ({
  score,
  requirements,
  highContrast = false,
}) => {
  const { label, severity } = strengthStatus(score);
  const hasRequirements = Array.isArray(requirements) && requirements.length > 0;

  if (!label && !hasRequirements) {
    return null;
  }

  return (
    <div
      className={s.wrapper}
      data-high-contrast={highContrast ? "true" : undefined}
    >
      {label && (
        <>
          <div className={s.header}>
            <span>Siła hasła:</span>
            <span className={s.statusLabel} data-severity={severity}>
              {label}
            </span>
          </div>
          <div className={s.bar} aria-hidden="true">
            <div className={s.barFill} data-score={String(score)} />
          </div>
        </>
      )}

      {hasRequirements && (
        <>
          <span className={s.missingHeader}>Wymagania hasła:</span>
          <ul className={s.missingList}>
            {requirements.map((req) => (
              <li
                key={req.key}
                className={s.requirementItem}
                data-met={req.met ? "true" : "false"}
              >
                <span className={s.requirementIcon} aria-hidden="true">
                  {req.met ? "✓" : "✗"}
                </span>
                <span>{req.text}</span>
              </li>
            ))}
          </ul>
        </>
      )}
    </div>
  );
};
